import { FirestoreDataConverter } from "firebase/firestore";
import moment from "moment";
import ResultadoInternacional, { DetalhePorMoeda } from "../models/resultadoInternacional";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class ResultadoInternacionalDb extends BaseDb<
  ResultadoInternacional,
  { usuarioId: string; resultadoId: string }
> {
  _path: string = "usuarios/usuarioId/resultadosInternacional/resultadoId";

  getConverter(): FirestoreDataConverter<ResultadoInternacional> {
    return {
      fromFirestore: (snapshot) => {
        return new ResultadoInternacional({
          dataBase: moment(snapshot.get("dataBase").toDate()),
          ganhoCapital: snapshot.get("ganhoCapital"),
          rendimentos: snapshot.get("rendimentos"),
          resultadoTotal: snapshot.get("resultadoTotal"),
          resultadoAcumulado: snapshot.get("resultadoAcumulado"),
          detalhesPorMoeda: snapshot.get("detalhesPorMoeda") as { [moeda: string]: DetalhePorMoeda },
        });
      },
      toFirestore: (resultado) => toFirestore(resultado),
    };
  }
}